<template>
  <main class="px-6 py-10">
    <div class="max-w-4xl mx-auto text-center mb-10">
      <h2 class="text-3xl font-bold mb-4">Building Community</h2>
      <p class="text-gray-700">
        Beyond his business endeavors, Arc. Barka Umaru Mshelia has dedicated
        himself to empowering people and organizations to unlock possibilities
        and create new opportunities for societal betterment. He founded the
        Mshel Foundation where everyone has the opportunity to pitch their
        dreams.
      </p>
    </div>

    <!-- Staggered Image Grid -->
    <div
      class="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 items-start"
    >
      <!-- Left column -->
      <div class="flex flex-col gap-6">
        <img
          src="../assets/images/pitch-your-dream1.jpg"
          alt=""
          class="rounded-lg shadow-md"
        />
        <img
          src="../assets/images/pitch-your-dream3.jpg"
          alt=""
          class="rounded-lg shadow-md"
        />
      </div>

      <!-- Right column -->
      <div class="flex flex-col gap-6 py-10">
        <img
          src="../assets/images/pitch-your-dream2.jpg"
          alt=""
          class="rounded-lg shadow-md"
        />
        <!-- <img
          src="../assets/images/pitch-your-dream4.jpg"
          alt=""
          class="rounded-lg shadow-md"
        /> -->
      </div>
    </div>
  </main>
</template>

<script>
export default {};
</script>

<style scoped></style>
